import scrollLoad from '~/utils/scrollLoad.js'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('scroll-load', scrollLoad)
})